var _rect, _rect2, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 0.3,
    width: 39.4,
    height: 39.4,
    rx: 19.7,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 0.3,
    width: 39.4,
    height: 39.4,
    rx: 19.7,
    stroke: "#E5E5E5",
    strokeWidth: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9473 14.9105L25.4825 22.4293C25.3637 24.3503 25.3044 25.3108 24.8229 26.0014C24.5847 26.3428 24.2783 26.631 23.9228 26.8475C23.2038 27.2855 22.2415 27.2855 20.3168 27.2855C18.3896 27.2855 17.426 27.2855 16.7066 26.8467C16.3509 26.6298 16.0443 26.3411 15.8063 25.9991C15.3249 25.3075 15.2669 24.3456 15.1507 22.4219L14.6973 14.9105",
    stroke: "#212129",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5723 14.9107H27.0723M23.364 14.9107L22.8521 13.8545C22.512 13.1529 22.3419 12.8021 22.0485 12.5833C21.9835 12.5348 21.9146 12.4916 21.8425 12.4542C21.5177 12.2857 21.1278 12.2857 20.3481 12.2857C19.5489 12.2857 19.1493 12.2857 18.819 12.4613C18.7458 12.5002 18.676 12.5451 18.6102 12.5956C18.3135 12.8232 18.1477 13.1869 17.8162 13.9142L17.362 14.9107",
    stroke: "#212129",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4473 23.1606V18.6606",
    stroke: "#212129",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1973 23.1606V18.6606",
    stroke: "#212129",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.636ebb0377515d482f91e0d222031fb8.svg";
export { ForwardRef as ReactComponent };